import Vue from 'vue';
import FormatterHelper from '@/scripts/helpers/formatter.helper.js'

Vue.filter('FormatDocument', (document) => {
    return FormatterHelper.formatDocument(document);
});